import type { WebsiteHeaderPhotoSchema_PhotoBackground } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_BACKGROUND_DEFAULT: WebsiteHeaderPhotoSchema_PhotoBackground = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',
  presentationLayout: 'photoBackground',
  photos: [],
  eventName: undefined,
  colors: undefined,
};
